import { _ as _objectSpread2 } from '../../_rollupPluginBabelHelpers-fb970440.js';
import { makeVar } from '@apollo/client';

var init_state = {
  intermediaryCode: '',
  intermediaryName: '',
  branchOfficeCode: '',
  branchOfficeName: '',
  fieldUserCode: '',
  fieldUserName: ''
};
var intermediaryVar = makeVar(init_state);
var initIntermediaryState = function initIntermediaryState() {
  intermediaryVar(init_state);
};
var updateAllIntermediaryFields = function updateAllIntermediaryFields(_ref) {
  var _intermediaryVar, _intermediaryVar2, _intermediaryVar3, _intermediaryVar4, _intermediaryVar5, _intermediaryVar6;

  var intermediaryCode = _ref.intermediaryCode,
      intermediaryName = _ref.intermediaryName,
      branchOfficeCode = _ref.branchOfficeCode,
      branchOfficeName = _ref.branchOfficeName,
      fieldUserCode = _ref.fieldUserCode,
      fieldUserName = _ref.fieldUserName;
  return intermediaryVar({
    intermediaryCode: intermediaryCode ? intermediaryCode : (_intermediaryVar = intermediaryVar()) === null || _intermediaryVar === void 0 ? void 0 : _intermediaryVar.intermediaryCode,
    intermediaryName: intermediaryName ? intermediaryName : (_intermediaryVar2 = intermediaryVar()) === null || _intermediaryVar2 === void 0 ? void 0 : _intermediaryVar2.intermediaryName,
    branchOfficeCode: branchOfficeCode ? branchOfficeCode : (_intermediaryVar3 = intermediaryVar()) === null || _intermediaryVar3 === void 0 ? void 0 : _intermediaryVar3.branchOfficeCode,
    branchOfficeName: branchOfficeName ? branchOfficeName : (_intermediaryVar4 = intermediaryVar()) === null || _intermediaryVar4 === void 0 ? void 0 : _intermediaryVar4.branchOfficeName,
    fieldUserCode: fieldUserCode ? fieldUserCode : (_intermediaryVar5 = intermediaryVar()) === null || _intermediaryVar5 === void 0 ? void 0 : _intermediaryVar5.fieldUserCode,
    fieldUserName: fieldUserName ? fieldUserName : (_intermediaryVar6 = intermediaryVar()) === null || _intermediaryVar6 === void 0 ? void 0 : _intermediaryVar6.fieldUserName
  });
};
var updateIntermediary = function updateIntermediary(code, name) {
  return intermediaryVar(_objectSpread2(_objectSpread2({}, intermediaryVar()), {}, {
    intermediaryCode: code,
    intermediaryName: name
  }));
};
var updateBusinessLocation = function updateBusinessLocation(code, name) {
  return intermediaryVar(_objectSpread2(_objectSpread2({}, intermediaryVar()), {}, {
    branchOfficeCode: code,
    branchOfficeName: name
  }));
};
var updateFieldUser = function updateFieldUser(code, name) {
  return intermediaryVar(_objectSpread2(_objectSpread2({}, intermediaryVar()), {}, {
    fieldUserCode: code,
    fieldUserName: name
  }));
};

export { initIntermediaryState, intermediaryVar, updateAllIntermediaryFields, updateBusinessLocation, updateFieldUser, updateIntermediary };
